/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListExternalKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Only return keys for this provider.
 */
export const ListExternalKeysQueryParamProvider = {
  AwsKms: "aws_kms",
  GcpKms: "gcp_kms",
} as const;
/**
 * Only return keys for this provider.
 */
export type ListExternalKeysQueryParamProvider = ClosedEnum<
  typeof ListExternalKeysQueryParamProvider
>;

export type ListExternalKeysRequest = {
  /**
   * Only return keys for this provider.
   */
  provider?: ListExternalKeysQueryParamProvider | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListExternalKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListExternalKeysSecurity$outboundSchema: z.ZodMiniType<
  ListExternalKeysSecurity$Outbound,
  ListExternalKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listExternalKeysSecurityToJSON(
  listExternalKeysSecurity: ListExternalKeysSecurity,
): string {
  return JSON.stringify(
    ListExternalKeysSecurity$outboundSchema.parse(listExternalKeysSecurity),
  );
}

/** @internal */
export const ListExternalKeysQueryParamProvider$outboundSchema: z.ZodMiniEnum<
  typeof ListExternalKeysQueryParamProvider
> = z.enum(ListExternalKeysQueryParamProvider);

/** @internal */
export type ListExternalKeysRequest$Outbound = {
  provider?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListExternalKeysRequest$outboundSchema: z.ZodMiniType<
  ListExternalKeysRequest$Outbound,
  ListExternalKeysRequest
> = z.pipe(
  z.object({
    provider: z.optional(ListExternalKeysQueryParamProvider$outboundSchema),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listExternalKeysRequestToJSON(
  listExternalKeysRequest: ListExternalKeysRequest,
): string {
  return JSON.stringify(
    ListExternalKeysRequest$outboundSchema.parse(listExternalKeysRequest),
  );
}
